import { useCallback, useEffect, useState } from 'react';
import { RuleDetailResponse } from '../../interfaces/rule';
import { getDetail } from '../../services/rulesService';

const useFetchRule = (ruleId: number) => {
  const [rule, setRule] = useState<RuleDetailResponse | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRule = useCallback(() => {
    setIsLoading(true);
    setError(null);

    getDetail(ruleId)
      .then((result) => {
        setRule(result);
      })
      .catch((err) => {
        setError(err.message || 'Error al obtener la regla');
        setRule(null);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [ruleId]);

  useEffect(() => {
    fetchRule();
  }, [fetchRule]);

  return {
    isLoading,
    error,
    rule,
  };
};

export default useFetchRule;
